module.exports = __webpack_public_path__ + "img/feature_optimize.60deeb78.svg";